// ============================================================
// Custom Collection Page Scripts
// 文件名：custom-collection.js
// ============================================================

document.addEventListener('DOMContentLoaded', function () {

  // ==========================================================
  // 区块 4：快捷标签筛选 - 鼠标拖拽横向滚动
  // ==========================================================
  const scrollers = document.querySelectorAll('.ctf-scroll');

  scrollers.forEach(function (el) {
    let isDown = false;
    let startX = 0;
    let startScrollLeft = 0;

    el.addEventListener('mousedown', function (e) {
      isDown = true;
      el.classList.add('dragging');
      startX = e.pageX - el.offsetLeft;
      startScrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', function () {
      isDown = false;
      el.classList.remove('dragging');
    });

    el.addEventListener('mouseup', function () {
      isDown = false;
      el.classList.remove('dragging');
    });

    el.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5;
      el.scrollLeft = startScrollLeft - walk;
    });
  });


  // ==========================================================
  // 区块 5：活动公告横幅 - 关闭按钮
  // ==========================================================
  const cabCloseButtons = document.querySelectorAll('.cab-close');

  cabCloseButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      const wrap = btn.closest('.cab-wrap');
      if (wrap) {
        wrap.classList.add('hidden');
      }
    });
  });


  // ==========================================================
  // 区块 8 & 10：通用横向滑块 - 左右箭头滚动
  // ==========================================================
  const sliderWraps = document.querySelectorAll('.ccs-wrap');

  sliderWraps.forEach(function (wrap) {
    const track = wrap.querySelector('.ccs-track');
    const prevBtn = wrap.querySelector('.ccs-arrow--prev');
    const nextBtn = wrap.querySelector('.ccs-arrow--next');

    if (!track || !prevBtn || !nextBtn) return;

    const step = 260;

    function updateArrows() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -step, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: step, behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateArrows);
    window.addEventListener('resize', updateArrows);

    updateArrows();
  });

});